import { Fragment, h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import LightningMap from './ui/LightningMap';
import { InfoPanel } from 'src/js/ui/panel/info';

window.addEventListener('hashchange', e => setTimeout(() => window.location.reload(), 10));

export interface IMapSettings {
    
}

export function Spinner(props: {}) {
    return <div className='spinner-border text-light' role='status'>
        <span className='visually-hidden'>Ladataan...</span>
    </div>;
}

function getInitialSettings() {
    
    if (window.location.hash) {
        const rawHash = window.location.hash.substring(1);
        try {
            const metaRaw = JSON.parse(decodeURIComponent(rawHash));
            if (metaRaw.stops && metaRaw.interval) {
                return metaRaw;
            }
        } catch (err) {}
    }
    
    return null;
    
}

export default function App(props: {}) {
    
    const [mapSettings, setMapSettings] = useState<IMapSettings>(getInitialSettings() || {});
    
    const [openInfoPanel, setOpenInfoPanel] = useState<string | null>(null);
    
    return <section className='x-app'>
        <main className='x-map'>
            <LightningMap
                settings={mapSettings}
                onSubPanel={toPanel => {
                    setOpenInfoPanel(toPanel);
                }}
                />
        </main>
        <InfoPanel 
            visible={openInfoPanel == 'info'}
            setPanel={to => setOpenInfoPanel(to)}
            />
    </section>;
    
}
